import { render, staticRenderFns } from "./LookupCodeEdit.vue?vue&type=template&id=12dfa860&scoped=true"
import script from "./LookupCodeEdit.vue?vue&type=script&lang=js"
export * from "./LookupCodeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfa860",
  null
  
)

export default component.exports